module.exports = __webpack_public_path__ + "static/media/calendarToday.4ef0e283.svg";